import { createSelector } from '@reduxjs/toolkit';
import selectWorkflows from './selectWorkflows';

export default createSelector(selectWorkflows, (workflows) =>
  [...workflows].sort((a, b) => a?.vendor?.localeCompare(b?.vendor))
);
